import * as React from "react";
import Typography from "../Typography";

import SelectArrow from "@/assets/icons/arrow/select.svg?react";
import { cn } from "@/shared/lib/utils";

export interface ISelectProps {
    list: Array<{id: number, name: number|string}>,
    selected: string | number | null,
    placeholder: string,
    className?: string,
    handleSelect: (id: number | null) => void
}

export function Select({ list, selected, placeholder, handleSelect, className }: ISelectProps) {
    
    const [showList, setShowList] = React.useState(false);

    const selectRef = React.useRef<HTMLDivElement>(null);

    const handleChange = (id: number | null) => {
        handleSelect(id);
        setShowList(false);
    }

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
                setShowList(false);
            }
        };

        if (showList) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showList]);

    return (
        <div ref={selectRef} className={cn("relative", className)}>
            <div 
                className="h-[36px] flex flex-row justify-between gap-[16px] px-[16px] items-center"
                onClick={()=>setShowList(prev => !prev)}
            >
                <Typography className="font-medium w-full text-[14px] md:text-[16px]">
                    {selected? list.find(el => el.id == selected)?.name: placeholder}
                </Typography>

                <SelectArrow className={cn(
                    "min-w-[13px] min-h-[7px] transition-all ease-linear duration-100",
                    showList && '-rotate-180'
                )}/>
            </div>
            {
                showList
                &&
                <div className="bg-white absolute rounded-[10px] left-0 top-[calc(100%+12px)] z-10 w-full p-[12px] shadow-bg max-h-[250px] scrollbar-thin overflow-y-auto">
                    <ul className="flex flex-col gap-[4px]">

                        <li
                            key={'all_key'}
                            className={cn(
                                "px-[8px] h-[26px] flex items-center rounded-[8px] cursor-pointer",
                                !selected ?
                                    'bg-light-blue': 'hover:bg-main-grey'
                            )}
                            onClick={()=>handleChange(null)}
                        >
                            <Typography className="text-[14px] md:text-[14px] font-medium">
                                Все
                            </Typography>
                        </li>

                        {list.map((item) => (
                            <li
                                key={item.id}
                                className={cn(
                                    "px-[8px] h-[26px] flex items-center rounded-[8px] cursor-pointer",
                                    selected && selected == item.id ?
                                        'bg-light-blue': 'hover:bg-main-grey'
                                )}
                                onClick={()=>handleChange(item.id)}
                            >
                                <Typography className="text-[14px] md:text-[14px] font-medium">
                                    {item.name}
                                </Typography>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>
    );
}
